import * as React from 'react';
import { IAppPropsWithRoute } from '../../common/types';
import { withRouter } from 'react-router-dom';
import { useState } from 'react';
import ViewUsersWidget from './ViewUsersWidget';
import { useDispatch, useSelector } from 'react-redux';
import { showNavbar } from '../../store/modules/appStateSlice';

interface ViewUsersPageProps extends IAppPropsWithRoute {

};

function ViewUsersPage(props: ViewUsersPageProps): JSX.Element {
    const dispatch = useDispatch();
    //const { authStore } = useSelector((state: RootState) => state);
    React.useEffect(() => {
        dispatch(showNavbar(true));
    }, [])
   
    return (
        <React.Fragment>
            <ViewUsersWidget/>
        </React.Fragment>
    );
}

export default React.memo(withRouter(ViewUsersPage));